import { FC } from "react";
import PageTemplate from "../PageTemplate";
import CreateWorkForm from "./CreateWorkForm";

const CreateWork: FC = () => {
    return <PageTemplate Page={CreateWorkForm} />;
};

export default CreateWork;
